// eslint-disable-next-line no-shadow
export enum ResponseStatus {
  ERROR = 0,
  SUCCESS = 1,
  UNAUTHORIZED = 401,
  NO_MSGAUDIT_CONFIG = 10000,
}

export class BaseDTO<T> {
  status: number;

  msg: string;

  data: T;

  constructor(status: number, msg: string, data: T) {
    this.status = status;
    this.msg = msg;
    this.data = data;
  }

  isSuccess() {
    return this.status === ResponseStatus.SUCCESS;
  }
}
